{% block swag_cms_extensions_form_element_checkbox %}
    <mt-checkbox
        :checked="value"
        :label="field.translated ? field.translated.label : field.label"
        :required="field.required"
        :disabled
    />
{% endblock %}
